var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginPageGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 499,
    viewBox: "0 0 726 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2569_24372)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 726,
    height: 499,
    fill: "#1F2E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.7517 74.4245C-63.7517 74.4245 95.0631 48.0289 195.503 101.437C303.301 158.761 399.814 199.461 485.5 197.621C565.065 195.913 779.303 154.844 867.924 219.865",
    stroke: "#FEFEFE",
    strokeWidth: 1.70839,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.943 319.014C878.943 319.014 720.127 292.619 619.688 346.027C511.891 403.349 415.378 444.054 329.69 442.211C250.126 440.503 35.8883 399.434 -52.7329 464.456",
    stroke: "#FEFEFE",
    strokeWidth: 1.70839,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.61997 38.6399C-10.5244 41.104 57.1077 206.324 235.091 224.29C356.563 236.553 551.791 141.677 628.608 103.66C711.595 62.5945 847.978 -3.73721 936.599 61.2821",
    stroke: "#FEFEFE",
    strokeWidth: 1.70839,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.222 265.457C860.127 267.921 792.495 433.143 614.512 451.109C493.039 463.369 297.812 368.49 220.994 330.479C138.005 289.413 1.62417 223.077 -87 288.098",
    stroke: "#FEFEFE",
    strokeWidth: 1.70839,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.672 194.691C659.533 194.691 666.717 187.508 666.717 178.646C666.717 169.785 659.533 162.602 650.672 162.602C641.81 162.602 634.627 169.785 634.627 178.646C634.627 187.508 641.81 194.691 650.672 194.691Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6244 287.462C49.4857 287.462 56.6692 280.279 56.6692 271.418C56.6692 262.556 49.4857 255.373 40.6244 255.373C31.7631 255.373 24.5796 262.556 24.5796 271.418C24.5796 280.279 31.7631 287.462 40.6244 287.462Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.651 436.203C726.997 436.203 732.141 431.058 732.141 424.712C732.141 418.366 726.997 413.222 720.651 413.222C714.305 413.222 709.16 418.366 709.16 424.712C709.16 431.058 714.305 436.203 720.651 436.203Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.137 335.354C664.45 335.354 669.568 330.237 669.568 323.923C669.568 317.61 664.45 312.492 658.137 312.492C651.824 312.492 646.706 317.61 646.706 323.923C646.706 330.237 651.824 335.354 658.137 335.354Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9214 438.287C38.2346 438.287 43.3525 433.169 43.3525 426.856C43.3525 420.543 38.2346 415.425 31.9214 415.425C25.6081 415.425 20.4902 420.543 20.4902 426.856C20.4902 433.169 25.6081 438.287 31.9214 438.287Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.924 162.603C478.081 162.603 480.64 160.043 480.64 156.886C480.64 153.73 478.081 151.17 474.924 151.17C471.767 151.17 469.208 153.73 469.208 156.886C469.208 160.043 471.767 162.603 474.924 162.603Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.402 231.092C587.559 231.092 590.118 228.533 590.118 225.376C590.118 222.219 587.559 219.66 584.402 219.66C581.245 219.66 578.686 222.219 578.686 225.376C578.686 228.533 581.245 231.092 584.402 231.092Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.503 415.425C130.66 415.425 133.219 412.866 133.219 409.709C133.219 406.552 130.66 403.993 127.503 403.993C124.346 403.993 121.787 406.552 121.787 409.709C121.787 412.866 124.346 415.425 127.503 415.425Z",
    fill: "#ADBBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.486 447.815C596.949 447.815 600.568 444.196 600.568 439.732C600.568 435.268 596.949 431.649 592.486 431.649C588.022 431.649 584.403 435.268 584.403 439.732C584.403 444.196 588.022 447.815 592.486 447.815Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6672 125.034C61.1311 125.034 64.7499 121.415 64.7499 116.951C64.7499 112.487 61.1311 108.869 56.6672 108.869C52.2032 108.869 48.5845 112.487 48.5845 116.951C48.5845 121.415 52.2032 125.034 56.6672 125.034Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.524 116.951C254.837 116.951 259.955 111.833 259.955 105.52C259.955 99.207 254.837 94.0891 248.524 94.0891C242.211 94.0891 237.093 99.207 237.093 105.52C237.093 111.833 242.211 116.951 248.524 116.951Z",
    fill: "#FFA584"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2569_24372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 726,
    height: 499,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageGraphic);
export default __webpack_public_path__ + "static/media/LoginPageGraphic.a44f72ffbf3fd43140e799b18c79e0a1.svg";
export { ForwardRef as ReactComponent };